export * from "./useIntl";

export type { AbstractIntlMessages, IntlConfig } from "use-intl";

export { I18nMessage } from "./components/I18nMessage";
export { DEFAULT_LOCALE } from "./constants/defaultLocale.constants";
export { locales } from "./lib/locales";
export type { I18nProviderProps } from "./providers/I18nProvider";
export { I18nProvider } from "./providers/I18nProvider";
export type { Locale } from "./types/locale.types";
export type { ConsoleErrorI18nReactProps } from "./utils/consoleErrorI18nReact";
export { getLocaleFromPath } from "./utils/getLocaleFromPath";
export type { MergeMessagesProps } from "./utils/mergeMessages";
export { mergeMessages } from "./utils/mergeMessages";
